const Status = {
  created: "Registered",
  registered: "Registered",
  approved: "Approved",
  rejected: "Rejected",
  Online: "Online",
  Offline: "Offline",
  true: "Yes",
  false: "No",
  yes: "Yes",
  no: "No",
  approved: "Approved",
  created: "New",
  rejected: "Rejected",
  accepted: "Accepted",
  1: "Submitted",
  submitted: "Submitted",
  0: "Pending",
  confirmed: "Confirmed",
  searching: "Searching",
  schedule: "scheduled",
  started: "Started",
  completed: "Completed",
  success: "Success",

  cancel: "Cancelled",
  Offline: "Offline",
  active: "Active",
  inactive: "Inactive",
  blocked: "Blocked",
  pending: "Pending",
  process: "Process",
  cancelled: "Cancelled",
  declined: "Declined",

  FindingTrips: "Waiting for order",
  PickupInroute: "Pick-up Inroute ",
  DestinationInroute: " Destination Inroute ",
  requestedAssignDriver: "Request To Driver",
  driverNotFound: "Driver Not Found",
  Completed: "Completed",
  complete: "Completed",
  Cancelled: "Cancelled",
  Declined: "Declined",
};
export default Status;
